(function () {
  'use strict';

  /* @ngdoc object
   * @name login.reset
   * @description
   *
   */
  angular
    .module('login.reset', [
      'ui.router'
    ]);
}());
